import { TransactionalAPIService } from "@app/services/Methods/api";
import { AlertCountResponse, AlertResponse } from "@app/types/API.types";

export const getAlertDetails = (
    licenseeId: string | undefined,
    pageNumber: number,
    pageSize: number,
    searchText?: string,
    alertSortColumn?: string,
    alertSortDirection?: number,
) =>
    TransactionalAPIService.get<AlertResponse>(
        `${licenseeId}/alert?${`pageNumber=${pageNumber}&`}${`pageSize=${pageSize}&`}${
            searchText ? `searchText=${searchText}&` : ""
        }${alertSortColumn ? `alertSortColumn=${alertSortColumn}&` : ""}${
            alertSortDirection ? `alertSortDirection=${alertSortDirection}` : ""
        }`,
    );

export const updateAlertStatus = (
    licenseeId: string,
    id: string,
    branchCode: string,
    status: number,
) => {
    const queryParams = new URLSearchParams({
        id,
        branchCode,
        status: status.toString(),
    }).toString();

    return TransactionalAPIService.put(`${licenseeId}/alert?${queryParams}`);
};

export const getAlertCount = (licenseeId: string | undefined) =>
    TransactionalAPIService.get<AlertCountResponse>(`${licenseeId}/alert/count`);
